<div>
  <div class="breadcrumb" style="margin-top: 0px">
    <span class="breadcrumb-previous" (click)="goTo('home')">Home</span> >
    <span class="breadcrumb-previous" (click)="goTo('landing')">Gestione Eventi</span>
    >
    <span class="breadcrumb-current">Nuovo Evento</span>
  </div>

  <div>
    <form name="myForm" #myForm>
      <div class="wrap-field">
        <div class="myformfieldtitle">
          <label for="eventTitle">Seleziona la lingua del titolo</label>
          <mat-button-toggle-group
            name="eventTitle"
            aria-label="Selezione Lingua"
            [(ngModel)]="selectedLangTitle"
          >
            <mat-button-toggle
              value="en"
              matTooltip="Inglese"
              matTooltipPosition="above"
            >
              <img
                src="../../../../assets/lang/en.png"
                alt="Inglese"
                style="width: 20px"
              />
            </mat-button-toggle>
            <mat-button-toggle
              value="it"
              matTooltip="Italiano"
              matTooltipPosition="above"
            >
              <img
                src="../../../../assets/lang/it.png"
                alt="Italiano"
                style="width: 20px"
              />
            </mat-button-toggle>
            <mat-button-toggle
              value="de"
              matTooltip="Tedesco"
              matTooltipPosition="above"
            >
              <img
                src="../../../../assets/lang/de.png"
                alt="Tedesco"
                style="width: 20px"
              />
            </mat-button-toggle>
            <mat-button-toggle
              value="fr"
              matTooltip="Francese"
              matTooltipPosition="above"
            >
              <img
                src="../../../../assets/lang/fr.png"
                alt="Francese"
                style="width: 20px"
              />
            </mat-button-toggle>
            <mat-button-toggle
              value="es"
              matTooltip="Spagnolo"
              matTooltipPosition="above"
            >
              <img
                src="../../../../assets/lang/es.png"
                alt="Spagnolo"
                style="width: 20px"
              />
            </mat-button-toggle>
            <mat-button-toggle
              value="pt"
              matTooltip="Portoghese"
              matTooltipPosition="above"
            >
              <img
                src="../../../../assets/lang/pr.png"
                alt="Portoghese"
                style="width: 20px"
              />
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div class="myformfield">
          @switch (selectedLangTitle) {
            @case ('it') {
              <mat-form-field appearance="outline">
                  <mat-label for="eventTitle">Titolo in Italiano</mat-label>
                  <input
                    matInput
                    type="text"
                    id="eventTitle"
                    name="eventTitle"
                    [(ngModel)]="eventModel.event_name_it"
                    maxlength="100"
                    #my_input_24="ngModel"
                    autocomplete="off"
                    required
                  />
                @if ( my_input_24.invalid &&
                (my_input_24.dirty || my_input_24.touched)) {
                  <mat-error>Titolo non valido</mat-error
                  >
                }
                </mat-form-field>
            }
            @case ('en') {
              <mat-form-field appearance="outline">
                <mat-label for="eventTitle">Titolo in Inglese</mat-label>
                <input
                  matInput
                  type="text"
                  id="eventTitle"
                  name="eventTitle"
                  [(ngModel)]="eventModel.event_name_en"
                  maxlength="100"
                  #my_input_25="ngModel"
                  autocomplete="off"
                  required
                />
                @if ( my_input_25.invalid &&
                (my_input_25.dirty || my_input_25.touched)) {
                  <mat-error>Titolo non valido</mat-error
                  >
                }
              </mat-form-field>
            }
            @case ('de') {
              <mat-form-field appearance="outline">
                <mat-label for="eventTitle">Titolo in Tedesco</mat-label>
                <input
                  matInput
                  type="text"
                  id="eventTitle"
                  name="eventTitle"
                  [(ngModel)]="eventModel.event_name_de"
                  maxlength="100"
                  #my_input_26="ngModel"
                  autocomplete="off"
                />
                @if ( my_input_26.invalid &&
                (my_input_26.dirty || my_input_26.touched)) {
                  <mat-error>Titolo non valido</mat-error
                  >
                }
              </mat-form-field>
            }
            @case ('fr') {
              <mat-form-field appearance="outline" >
                <mat-label for="eventTitle">Titolo in Francese</mat-label>
                <input
                  matInput
                  type="text"
                  id="eventTitle"
                  name="eventTitle"
                  [(ngModel)]="eventModel.event_name_fr"
                  maxlength="100"
                  #my_input_27="ngModel"
                  autocomplete="off"
                />
                @if ( my_input_27.invalid &&
                (my_input_27.dirty || my_input_27.touched)) {
                  <mat-error>Titolo non valido</mat-error
                  >
                }
              </mat-form-field>
            }
            @case ('es') {
              <mat-form-field appearance="outline" >
                <mat-label for="eventTitle">Titolo in Spagnolo</mat-label>
                <input
                  matInput
                  type="text"
                  id="eventTitle"
                  name="eventTitle"
                  [(ngModel)]="eventModel.event_name_es"
                  maxlength="100"
                  #my_input_28="ngModel"
                  autocomplete="off"
                />
                @if ( my_input_28.invalid &&
                (my_input_28.dirty || my_input_28.touched)) {
                  <mat-error>Titolo non valido</mat-error
                  >
                }
              </mat-form-field>
            }
            @case ('pt') {
              <mat-form-field appearance="outline">
                <mat-label for="eventTitle">Titolo in Portoghese</mat-label>
                <input
                  matInput
                  type="text"
                  id="eventTitle"
                  name="eventTitle"
                  [(ngModel)]="eventModel.event_name_pt"
                  maxlength="100"
                  #my_input_29="ngModel"
                  autocomplete="off"
                />
                @if ( my_input_29.invalid &&
                (my_input_29.dirty || my_input_29.touched)) {
                  <mat-error>Titolo non valido</mat-error
                  >
                }
              </mat-form-field>
            }

          }
        </div>
      </div>

      <div class="wrap-flex">
        <!-- <div class="wrap-field">
          <div class="myformfield">
            <mat-form-field appearance="outline">
              <mat-label>Inserisci la descrizione breve</mat-label>
              <textarea type="text" id="eventDescriptionShortIT" name="eventDescriptionShortIT" #my_input_2="ngModel"
                [(ngModel)]="eventModel.event_short_description_it" autocomplete="off" maxlength="300" matInput
                cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="20" required></textarea>
              <mat-error *ngSwitchCase="my_input_2.invalid && (my_input_2.dirty || my_input_2.touched)">Descrizione breve non
                valida</mat-error>
            </mat-form-field>
          </div>
        </div> -->

        <!-- <div class="wrap-field">
          <div class="myformfield">
            <mat-form-field appearance="outline">
              <mat-label>Inserisci la descrizione lunga</mat-label>
              <textarea matInput type="text" id="eventDescriptionLongIT" name="eventDescriptionLongIT"
                #my_input_3="ngModel" [(ngModel)]="eventModel.event_long_description_it" autocomplete="off"
                maxlength="1000" cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="20"
                required></textarea>
              <mat-error *ngIf="my_input_3.invalid && (my_input_3.dirty || my_input_3.touched)">Descrizione lunga non
                valida</mat-error>
            </mat-form-field>
          </div>
        </div> -->

        <div class="wrap-field">
          <div class="myformfieldtitle">
            <label for="eventDescriptionShort"
              >Seleziona la lingua della descrizione</label
            >
            <mat-button-toggle-group
              name="eventDescriptionShort"
              aria-label="Selezione Lingua"
              [(ngModel)]="selectedLangShort"
            >
              <mat-button-toggle
                value="en"
                matTooltip="Inglese"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/en.png"
                  alt="Inglese"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="it"
                matTooltip="Italiano"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/it.png"
                  alt="Italiano"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="de"
                matTooltip="Tedesco"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/de.png"
                  alt="Inglese"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="fr"
                matTooltip="Francese"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/fr.png"
                  alt="Inglese"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="es"
                matTooltip="Spagnolo"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/es.png"
                  alt="Spagnolo"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="pt"
                matTooltip="Portoghese"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/pr.png"
                  alt="Portoghese"
                  style="width: 20px"
                />
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div class="myformfield">
            @switch (selectedLangShort) {
              @case ('it') {
                <mat-form-field appearance="outline">
                  <mat-label>Inserisci la descrizione breve</mat-label>
                  <textarea
                    type="text"
                    id="eventDescriptionShortIT"
                    name="eventDescriptionShortIT"
                    #my_input_2="ngModel"
                    [(ngModel)]="eventModel.event_short_description_it"
                    autocomplete="off"
                    maxlength="300"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                    required
                  ></textarea>
                  @if ( my_input_2.invalid &&
                  (my_input_2.dirty || my_input_2.touched)) {
                    <mat-error>Descrizione breve non valida</mat-error
                    >
                  }
                </mat-form-field>
              }

              @case ('en') {
                <mat-form-field appearance="outline" >
                  <mat-label>Inserisci la descrizione breve in Inglese</mat-label>
                  <textarea
                    type="text"
                    id="eventDescriptionShortEN"
                    name="eventDescriptionShortEN"
                    #my_input_13="ngModel"
                    [(ngModel)]="eventModel.event_short_description_en"
                    autocomplete="off"
                    maxlength="300"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                    required
                  ></textarea>
                  @if ( my_input_13.invalid &&
                  (my_input_13.dirty || my_input_13.touched)) {
                    <mat-error>Descrizione breve non valida</mat-error
                    >
                  }
                </mat-form-field>
              }

              @case ('de') {
                <mat-form-field appearance="outline" >
                  <mat-label>Inserisci la descrizione breve in Tedesco</mat-label>
                  <textarea
                    type="text"
                    id="eventDescriptionShortEN"
                    name="eventDescriptionShortEN"
                    #my_input_14="ngModel"
                    [(ngModel)]="eventModel.event_short_description_de"
                    autocomplete="off"
                    maxlength="300"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                  ></textarea>
                  @if ( my_input_14.invalid &&
                  (my_input_14.dirty || my_input_14.touched)) {
                    <mat-error>Descrizione breve non valida</mat-error
                    >
                  }
                </mat-form-field>
              }

              @case ('fr') {
                <mat-form-field appearance="outline">
                  <mat-label
                    >Inserisci la descrizione breve in Francese</mat-label
                  >
                  <textarea
                    type="text"
                    id="eventDescriptionShortEN"
                    name="eventDescriptionShortEN"
                    #my_input_15="ngModel"
                    [(ngModel)]="eventModel.event_short_description_fr"
                    autocomplete="off"
                    maxlength="300"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                  ></textarea>
                  @if ( my_input_15.invalid &&
                  (my_input_15.dirty || my_input_15.touched)) {
                    <mat-error>Descrizione breve non valida</mat-error
                    >
                  }
                </mat-form-field>
              }

              @case ('es') {
                <mat-form-field appearance="outline">
                  <mat-label for="eventTitle"
                    >Inserisci la descrizione breve in Spagnolo</mat-label
                  >
                  <textarea
                    type="text"
                    id="eventDescriptionShortEN"
                    name="eventDescriptionShortEN"
                    #my_input_30="ngModel"
                    [(ngModel)]="eventModel.event_short_description_es"
                    autocomplete="off"
                    maxlength="300"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                  ></textarea>
                  @if ( my_input_30.invalid &&
                  (my_input_30.dirty || my_input_30.touched)) {
                    <mat-error>Descrizione breve non valida</mat-error
                    >
                  }
                </mat-form-field>
              }

              @case ('pt') {
                <mat-form-field appearance="outline">
                  <mat-label for="eventTitle"
                    >Inserisci la descrizione breve in Portoghese</mat-label
                  >
                  <textarea
                    type="text"
                    id="eventDescriptionShortEN"
                    name="eventDescriptionShortEN"
                    #my_input_31="ngModel"
                    [(ngModel)]="eventModel.event_short_description_pt"
                    autocomplete="off"
                    maxlength="300"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                  ></textarea>
                  @if ( my_input_31.invalid &&
                  (my_input_31.dirty || my_input_31.touched)) {
                    <mat-error>Descrizione breve non valida</mat-error
                    >
                  }
                </mat-form-field>
              }
            }
          </div>
        </div>
        <!-- </div> -->

        <div class="wrap-field">
          <div class="myformfieldtitle">
            <label for="eventDescriptionLong"
              >Seleziona la lingua della descrizione</label
            >
            <mat-button-toggle-group
              name="eventDescriptionLong"
              aria-label="Selezione Lingua"
              [(ngModel)]="selectedLangLong"
            >
              <mat-button-toggle
                value="en"
                matTooltip="Inglese"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/en.png"
                  alt="Inglese"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="it"
                matTooltip="Italiano"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/it.png"
                  alt="Italiano"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="de"
                matTooltip="Tedesco"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/de.png"
                  alt="Inglese"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="fr"
                matTooltip="Francese"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/fr.png"
                  alt="Inglese"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="es"
                matTooltip="Spagnolo"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/es.png"
                  alt="Spagnolo"
                  style="width: 20px"
                />
              </mat-button-toggle>
              <mat-button-toggle
                value="pt"
                matTooltip="Portoghese"
                matTooltipPosition="above"
              >
                <img
                  src="../../../../assets/lang/pr.png"
                  alt="Portoghese"
                  style="width: 20px"
                />
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div class="myformfield">
            @switch (selectedLangLong) {
              @case ('it') {
                <mat-form-field appearance="outline">
                  <mat-label>Inserisci la descrizione lunga</mat-label>
                  <textarea
                    matInput
                    type="text"
                    id="eventDescriptionLongIT"
                    name="eventDescriptionLongIT"
                    #my_input_3="ngModel"
                    [(ngModel)]="eventModel.event_long_description_it"
                    autocomplete="off"
                    maxlength="1000"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                    required
                  ></textarea>
                  @if (my_input_3.invalid &&
                      (my_input_3.dirty || my_input_3.touched)){
                    <mat-error>Descrizione lunga non valida</mat-error>
                  }
                </mat-form-field>
              }

              @case ('en') {
                <mat-form-field appearance="outline">
                  <mat-label>Inserisci la descrizione lunga in Inglese</mat-label>
                  <textarea
                    matInput
                    type="text"
                    id="eventDescriptionLongEN"
                    name="eventDescriptionLongEN"
                    #my_input_16="ngModel"
                    [(ngModel)]="eventModel.event_long_description_en"
                    autocomplete="off"
                    maxlength="1000"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                    required
                  ></textarea>
                  @if (my_input_16.invalid &&
                  (my_input_16.dirty || my_input_16.touched)){
                    <mat-error>Descrizione lunga non valida</mat-error>
                  }
                </mat-form-field>
              }

              @case ('de') {
                <mat-form-field appearance="outline">
                  <mat-label>Inserisci la descrizione lunga in Tedesco</mat-label>
                  <textarea
                    matInput
                    type="text"
                    id="eventDescriptionLongDE"
                    name="eventDescriptionLongDE"
                    #my_input_17="ngModel"
                    [(ngModel)]="eventModel.event_long_description_de"
                    autocomplete="off"
                    maxlength="1000"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                  ></textarea>
                  @if (my_input_17.invalid &&
                  (my_input_17.dirty || my_input_17.touched)){
                    <mat-error>Descrizione lunga non valida</mat-error>
                  }
                </mat-form-field>
              }
              @case ('fr') {
                 <mat-form-field appearance="outline">
                  <mat-label
                    >Inserisci la descrizione lunga in Francese</mat-label
                  >
                  <textarea
                    matInput
                    type="text"
                    id="eventDescriptionLongFR"
                    name="eventDescriptionLongFR"
                    #my_input_18="ngModel"
                    [(ngModel)]="eventModel.event_long_description_fr"
                    autocomplete="off"
                    maxlength="1000"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                  ></textarea>
                   @if (my_input_18.invalid &&
                   (my_input_18.dirty || my_input_18.touched)){
                     <mat-error>Descrizione lunga non valida</mat-error>
                   }
                </mat-form-field>
              }
              @case ('es') {
                 <mat-form-field appearance="outline">
                  <mat-label for="eventTitle"
                    >Inserisci la descrizione breve in Spagnolo</mat-label
                  >
                  <textarea
                    matInput
                    type="text"
                    id="eventDescriptionLongFR"
                    name="eventDescriptionLongFR"
                    #my_input_32="ngModel"
                    [(ngModel)]="eventModel.event_long_description_es"
                    autocomplete="off"
                    maxlength="1000"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                  ></textarea>
                   @if (my_input_32.invalid &&
                   (my_input_32.dirty || my_input_32.touched)){
                     <mat-error>Descrizione lunga non valida</mat-error>
                   }
                </mat-form-field>
              }
              @case ('pt') {
                 <mat-form-field appearance="outline">
                  <mat-label for="eventTitle"
                    >Inserisci la descrizione breve in Portoghese</mat-label
                  >
                  <textarea
                    matInput
                    type="text"
                    id="eventDescriptionLongFR"
                    name="eventDescriptionLongFR"
                    #my_input_33="ngModel"
                    [(ngModel)]="eventModel.event_long_description_pt"
                    autocomplete="off"
                    maxlength="1000"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="20"
                  ></textarea>
                   @if (my_input_33.invalid &&
                   (my_input_33.dirty || my_input_33.touched)){
                     <mat-error>Descrizione lunga non valida</mat-error>
                   }
                </mat-form-field>
              }

            }
          </div>
        </div>
      </div>

      <!-- <div class="wrap-flex"> -->
      <div class="wrap-field">
        <div class="myformfield">
          <mat-form-field appearance="outline">
            <mat-label>Inserisci la categoria</mat-label>
            <mat-select
              #my_input_4="ngModel"
              [(ngModel)]="eventModel.fk_event_category"
              id="eventCategoryLong"
              name="eventCategoryLong"
              required
            >
              @for (category of listCategory; track category.id_event_category) {
                <mat-option [value]="category.id_event_category">
                  {{ category.name }}
                </mat-option>
              }
            </mat-select>
            @if (my_input_4.invalid &&
            (my_input_4.dirty || my_input_4.touched)){
              <mat-error>Descrizione lunga non valida</mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <!-- <div class="wrap-field">
          <div class="myformfield">
            <mat-form-field appearance="outline">
              <mat-label>Inserisci la location</mat-label>
              <input matInput type="text" placeholder="Inserisci location" aria-label="Number" [formControl]="myControl"
                [matAutocomplete]="auto" required>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div> -->
      <!-- </div> -->

      <!-- Global ID field -->
      <div class="myformfield">
        <mat-form-field appearance="outline">
          <mat-label for="eventGlobalId">Global ID</mat-label>
          <input
            matInput
            type="text"
            id="eventGlobalId"
            name="eventGlobalId"
            [(ngModel)]="eventModel.global_id"
            maxlength="100"
            #my_input_1="ngModel"
            autocomplete="off"
          />
          @if (my_input_1.invalid && (my_input_1.dirty || my_input_1.touched)) {
            <mat-error>Global ID non valido</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- SHIP ID field -->
      <div class="wrap-field">
        <div class="myformfield">
          <mat-form-field appearance="outline">
            <mat-label>Ship ID</mat-label>
            <mat-select
              #my_input_34="ngModel"
              [(ngModel)]="eventModel.fk_ship"
              id="idShip"
              name="shipName"
              required
            >
              @for (ship of listShips; track ship.id_ship) {
                <mat-option [value]="ship.id_ship">
                  {{ ship.ship_name }}
                </mat-option>
              }
            </mat-select>
            @if (my_input_34.invalid && (my_input_34.dirty || my_input_34.touched)) {
              <mat-error>Ship ID non valido</mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="wrap-flex">
        <div class="wrap-field">
          <div class="myformfield toggle">
            <label for="eventReserved">Evento riservato ai maggiorenni:</label>
            <mat-slide-toggle
              #my_input_5="ngModel"
              id="eventReserved"
              name="eventReserved"
              [(ngModel)]="eventModel.min_age_reservable"
            ></mat-slide-toggle>
          </div>
        </div>
        <div class="wrap-field">
          <div class="myformfield toggle">
            <label for="eventPerPassegerReservable"
              >Evento con prenotazioni limitate a
              {{ maxPerPassengerReservableLabel }}</label
            >
            <mat-slide-toggle
              #my_input_10="ngModel"
              id="eventPerPassegerReservable"
              name="eventPerPassegerReservable"
              [(ngModel)]="eventModel.max_per_passenger_reservable"
            ></mat-slide-toggle>
          </div>
        </div>
      </div>

      <div class="wrap-flex">
        <div class="wrap-field">
          <div class="myformfield flex">
            <mat-form-field appearance="outline">
              <mat-label>Inserisci gruppo</mat-label>
              <input
                matInput
                type="text"
                id="eventGruppo"
                name="eventGruppo"
                #my_input_6="ngModel"
                [(ngModel)]="group.id_group"
                autocomplete="off"
                minlength="3"
                maxlength="50"
              />
              @if (my_input_6.invalid && (my_input_6.dirty || my_input_6.touched)) {
                <mat-error>Gruppo non valido (lunghezza min. 3, lunghezza max. 50)</mat-error>
              }
            </mat-form-field>
            <button
              class="my-button confirm"
              mat-raised-button
              (click)="addGroup(group)"
            >
              Aggiungi Gruppo
            </button>
          </div>
        </div>
        <div class="wrap-field">
          <div class="myformfield">
            <h4>Riservato ai seguenti gruppi:</h4>
            @if (eventModel.event_groups?.length === 0) {
              Nessun gruppo esistente
            }@else {
              @for (group of eventModel.event_groups; let i = $index; track group.id_group) {
                <div class="groups">
                  {{ group.id_group }}
                  <button
                    class="my-button confirm small text-right"
                    mat-raised-button
                    (click)="removeGroup(i)">
                    <mat-icon>remove</mat-icon>
                  </button>
                </div>
              }
            }
          </div>
        </div>
      </div>

      <div class="wrap-flex">
        <div class="wrap-field">
          <div class="myformfield flex">
            <mat-form-field appearance="outline">
              <mat-label>Seleziona una data evento</mat-label>
              <input
                matInput
                id="eventDate"
                name="eventDate"
                #my_input_7="ngModel"
                [(ngModel)]="date"
                [matDatepicker]="picker"
                [min]="minDate"
                [appDateValidator]="eventModel.event_dates"
                dateFormat="DD/MM/YYYY"
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>

              @if (my_input_7.hasError('invalidDate')) {
                <mat-error>
                  Il formato della data non è valido.
                </mat-error>
              }
              @if (my_input_7.hasError('duplicateDate')) {
                <mat-error>
                  Questa data è già presente.
                </mat-error>
              }
            </mat-form-field>

            <button
              class="my-button confirm"
              mat-raised-button
              (click)="addDate(date)"
              [disabled]="my_input_7.invalid || !date"
            >
              Aggiungi Data Evento
            </button>
          </div>
        </div>
        <div class="wrap-field">
          <div class="myformfield">
            <mat-accordion class="accordion-dates" multi>
              @for (event_date of eventModel.event_dates | sortDates; let i = $index; track i) {
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div>
                        {{ event_date.date | date : "dd/MM/yyyy" }}
                      </div>
                    </mat-panel-title>
                    <mat-panel-description>
                      Gestisci Orari
                      <div style="padding: 5px 0px">
                        <button
                          class="my-button confirm small"
                          mat-raised-button
                          (click)="removeDate(event_date)"
                        >
                          <mat-icon>remove</mat-icon>
                        </button>
                      </div>
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <div class="my-row following-row">
                    <label for="eventSlots">Orari Evento:</label>
                  </div>

                  <div class="my-row">
                    <div class="my-row-element-3">
                      @if (event_date.event_slots?.length === 0) {
                        Nessuno slot esistente
                      }@else{
                        @for (slot of event_date.event_slots; let i = $index; track i) {
                          <div class="slots">
                            {{ slot.start_time }} : {{ slot.end_time }} - Capacità:
                            {{ slot.max_users }}
                            @if (slot.detail) {
                              <span>Dettaglio: {{ slot.detail }}</span>
                            }
                          </div>
                        }
                      }
                    </div>
                  </div>

                  <div class="my-row following-row">
                    <button
                      class="my-button confirm"
                      style="margin-left: 0px"
                      mat-raised-button
                      (click)="
                        openSettingsSlots(event_date, isFluxSpa(my_input_4.value))
                      "
                    >
                      Modifica Orari
                    </button>
                  </div>
                </mat-expansion-panel>
              }
            </mat-accordion>
          </div>
        </div>
      </div>

      <div class="wrap-flex booking-opening-mode">
        <div class="wrap-field">
          <mat-label>Modalità apertura prenotazioni: </mat-label>
          <mat-radio-group
            class="radio-group"
            name="openingModeOptions"
            [(ngModel)]="selectedMode">

            <mat-radio-button class="radio-button" [value]="openingModeEnum.FIRST_OCCURRENCE">
              sulla prima occorrenza dell'evento
            </mat-radio-button>

            <mat-radio-button class="radio-button" [value]="openingModeEnum.EACH_OCCURRENCE">
              su ciascuna occorrenza dell'evento
            </mat-radio-button>

          </mat-radio-group>

        </div>
      </div>

      <div class="wrap-flex">
        <div class="wrap-field">
          <div class="myformfield flex">
            <mat-form-field appearance="outline">
              <mat-label>
                Apertura prenotazioni: {{ selectedMode == openingModeEnum.FIRST_OCCURRENCE ?
                '(calcolata antecedentemente alla prima occorrenza dell\'evento)' :
                '(calcolata antecedentemente a ciascuna occorrenza dell\'evento)' }}
              </mat-label>
              <input
                matInput
                type="number"
                id="eventPreviousDays"
                name="eventPreviousDays"
                #my_input_8="ngModel"
                [(ngModel)]="eventModel.time_reservable_before_slot"
                [min]="0"
                [max]="999"
                required
                [disabled]="!selectedMode"
              />
              @if (my_input_8.invalid && (my_input_8.dirty || my_input_8.touched)) {
                <mat-error>Numero ore non valido</mat-error>
              }
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="margin-left: 15px; max-width: 250px"
            >
              <mat-select
                #my_input_22="ngModel"
                [(ngModel)]="selectedTimeTypeApertura"
                id="eventTypeTimeCO"
                name="eventTypeTimeCO"
                required
                [disabled]="!selectedMode"
              >
                @for (el of optionsTypeTime; track el.code) {
                  <mat-option [value]="el">
                    {{ el.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="wrap-flex">
        <div class="wrap-field">
          <div class="myformfield flex">
            <mat-form-field appearance="outline">
              <mat-label
                >Chiusura prenotazioni: (calcolata dall'inizio di ciascuna
                occorrenza dell'evento)</mat-label
              >
              <input
                matInput
                type="number"
                id="eventAfterDays"
                name="eventAfterDays"
                #my_input_9="ngModel"
                [(ngModel)]="eventModel.end_time_reservable_before_slot"
                [min]="0"
                [max]="999"
                required
              />
              @if (my_input_9.invalid && (my_input_9.dirty || my_input_9.touched)) {
                <mat-error>Numero ore non valido</mat-error>
              }
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="margin-left: 15px; max-width: 250px"
            >
              <mat-select
                #my_input_22="ngModel"
                [(ngModel)]="selectedTimeTypeChiusura"
                id="eventTypeTimePR"
                name="eventTypeTimePR"
                required
              >
                @for (el of optionsTypeTime; track el.code) {
                  <mat-option [value]="el">
                    {{ el.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="margin-left: 15px; max-width: 250px"
            >
              <mat-select
                #my_input_20="ngModel"
                [(ngModel)]="selectedTimeRelativeChiusura"
                id="eventTypeOre"
                name="eventTypeOre"
                required
              >
                @for (el of optionsRelativeTime; track el.code) {
                  <mat-option [value]="el">
                    {{ el.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="wrap-flex">
        <div class="wrap-field">
          <div class="myformfield">
            <mat-form-field appearance="outline">
              <mat-label>Dimensione lista di attesa</mat-label>
              <input
                matInput
                type="number"
                id="eventListaAttesa"
                name="eventListaAttesa"
                #my_input_11="ngModel"
                [(ngModel)]="eventModel.max_users_wl"
                [min]="0"
                [max]="999"
                required
              />
              @if (my_input_11.invalid &&
              (my_input_11.dirty || my_input_11.touched)) {
                <mat-error>Dimensione non valida</mat-error>
              }

            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="wrap-flex">
        <div class="wrap-field">
          <div class="myformfield flex">
            <mat-form-field appearance="outline">
              <mat-label
                >Chiusura Lista di attesa: (calcolata dall'inizio di ciascuna
                occorrenza dell'evento)</mat-label
              >
              <input
                matInput
                type="number"
                id="eventOrarioListaAttesa"
                name="eventOrarioListaAttesa"
                #my_input_12="ngModel"
                [(ngModel)]="eventModel.waiting_list_end_time"
                [min]="0"
                [max]="999"
                required
              />
              @if (my_input_12.invalid &&
              (my_input_12.dirty || my_input_12.touched)) {
                <mat-error>Numero ore non valido</mat-error>
              }
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="margin-left: 15px; max-width: 250px"
            >
              <mat-select
                #my_input_23="ngModel"
                [(ngModel)]="selectedTimeTypeChiusuraWL"
                id="eventTypeTimeLA"
                name="eventTypeTimeLA"
                required
              >
                @for (el of optionsTypeTime; track el.code) {
                  <mat-option [value]="el">
                    {{ el.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="margin-left: 15px; max-width: 250px"
            >
              <mat-select
                #my_input_21="ngModel"
                [(ngModel)]="selectedTimeRelativeChiusuraWL"
                id="eventTypeOre"
                name="eventTypeOre"
                required
              >
                @for (el of optionsRelativeTime; track el.code) {
                  <mat-option [value]="el">
                    {{ el.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <div class="my-button-container">
      <button
        class="my-button confirm"
        mat-raised-button
        (click)="save(myForm)"
        [disabled]="
          !myForm.checkValidity() || isSaveDisabled() || !requiredLangs()
        "
      >
        SALVA
      </button>
      <!-- <button class="my-button confirm" mat-raised-button (click)="save(myForm)">SALVA</button> -->
    </div>
  </div>
</div>
